import React from 'react';
import { motion } from 'framer-motion';
import type { CityInfo } from './cityData';

type Props = { city: CityInfo; onOpen: (slug: string) => void };

// Tek kart; shared element için layoutId atıyoruz
export default function CityCard({ city, onOpen }: Props) {
  return (
    <motion.article
      layout
      layoutId={`card-${city.slug}`}
      onClick={() => onOpen(city.slug)}
      className="cursor-pointer rounded-2xl overflow-hidden border border-[#f5fefd] bg-white dark:bg-card-dark dark:border-border-dark shadow-[0_18px_40px_rgba(15,23,42,0.08)] transition will-change-transform hover:scale-[1.02]"
    >
      <div className="relative">
        <motion.img
          layoutId={`img-${city.slug}`}
          src={city.cover}
          alt={city.name}
          loading="lazy"
          className="w-full aspect-[16/9] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
      </div>
      <div className="p-4">
        <motion.h3
          layoutId={`ttl-${city.slug}`}
          className="text-gray-900 dark:text-text-light font-semibold text-lg leading-tight mb-1"
        >
          {city.name}
        </motion.h3>
        <p className="text-gray-600 dark:text-gray-400 text-sm line-clamp-2">{city.teaser}</p>
      </div>
    </motion.article>
  );
}
